/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from "./syndication.defs.js";
export { main as default } from "./syndication.defs.js";
